import { render, staticRenderFns } from "./FundDetails.vue?vue&type=template&id=5d0bc4a4&scoped=true"
import script from "./FundDetails.vue?vue&type=script&lang=js"
export * from "./FundDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0bc4a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d0bc4a4')) {
      api.createRecord('5d0bc4a4', component.options)
    } else {
      api.reload('5d0bc4a4', component.options)
    }
    module.hot.accept("./FundDetails.vue?vue&type=template&id=5d0bc4a4&scoped=true", function () {
      api.rerender('5d0bc4a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/applet/dialogs/FundDetails.vue"
export default component.exports